/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import moment, { Moment } from 'moment';
import { ENVIRONMENT } from '../../../../environment/environment';

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
})
export class ReleaseNotesComponent {
    ReleaseType = ReleaseType;
    TabType = TabType;
    isDev = !ENVIRONMENT.production;
    tabs = !this.isDev ? [TabType['Release Update']] : [TabType['Release Update'], TabType['Known Issues']];

    releaseNoteList: ReleaseNoteModel[] = [
        {
            version: 'v0.0.110',
            date: moment('2026-02-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/96874/',
                            description: '[Web] AAE - Chinese New Year/ festive season announcement popup',
                            taskNo: 96874,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/93382/',
                            description: '[Web] support TIN number',
                            taskNo: 93382,
                        }
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/93120/',
                            description: '[Web] fix video player destroy sequence',
                            taskNo: 93120,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.108',
            date: moment('2025-12-02'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/89680/',
                            description: '[Web] AAE - set question list row clickable',
                            taskNo: 89680,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/88106/',
                            description: '[Web] AAE - hide "increase minutes" button',
                            taskNo: 88106,
                        }
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/87693/',
                            description: '[Web] Program - fix Programs progress bar percentage display',
                            taskNo: 87693,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.106',
            date: moment('2025-10-14'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/84307/',
                            description: '[Web] AAE - handle insufficient balance popup when submit',
                            taskNo: 84307,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/83827/',
                            description: '[Web] Register - enhance get planID and agentCode when register new user',
                            taskNo: 83827,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/84631/',
                            description: '[Web] fix mobile video player',
                            taskNo: 84631,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/82649/',
                            description: '[Web] fix register webinar mandarin copy',
                            taskNo: 82649,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.104',
            date: moment('2025-09-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/81699/',
                            description: '[Web] fix site copy and my cert CPE display',
                            taskNo: 81699,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.103',
            date: moment('2025-09-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/80464/',
                            description: '[Web] hide customer update card section',
                            taskNo: 80464,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/79592/',
                            description: '[Web] update AAE popup message copy',
                            taskNo: 79592,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/79212/',
                            description: '[Web] comment out CSP from project',
                            taskNo: 79212,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/79163/',
                            description: '[Web] AAE - delay notice popup handle by firebase',
                            taskNo: 79163,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/78828/',
                            description: '[Web] General - add proccessing overlay when loading calendar and quick guide',
                            taskNo: 78828,
                        }
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/80109/',
                            description: '[Web] fix Web translation display',
                            taskNo: 80109,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/79211/',
                            description: '[Web] Check is authorized based on accessToken and refreshToken',
                            taskNo: 79211,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/78931/',
                            description: '[Web] General - fix rich text container list intent',
                            taskNo: 78931,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.102',
            date: moment('2025-08-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77510/',
                            description: '[Web] update general network error message copy',
                            taskNo: 77510,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77381/',
                            description: '[Web] My training hours/ CPE - display completed date',
                            taskNo: 77381,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77321/',
                            description: '[Web] set cache control',
                            taskNo: 77321,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77251/',
                            description: '[Web] Stripe error response prompt',
                            taskNo: 77251,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77163/',
                            description: '[Web] General - include polling 401 handling',
                            taskNo: 77163,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/77016/',
                            description: '[Web] Video Player - fix 401 handling',
                            taskNo: 77016,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.101',
            date: moment('2025-08-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/76118/',
                            description: '[Web] Vimeo Player - add retry on update-progress failed',
                            taskNo: 76118,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75474/',
                            description: '[Web] User - change BRN number maxlength',
                            taskNo: 75474,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75419/',
                            description: '[Web] Program - handle Zoom rehearsal case',
                            taskNo: 75419,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75314/',
                            description: '[Web] Menu - update top menu handling - disable course selection',
                            taskNo: 75314,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75304/',
                            description: '[Web] Program vimeo player add extra handling',
                            taskNo: 75304,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75249/',
                            description: '[Web] General - TnC and Privacy Policy page',
                            taskNo: 75249,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75140/',
                            description: '[Web] Subscription - renewal link fix get param to lowercase',
                            taskNo: 75140,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75093/',
                            description: '[Web] Program - video progress change detection',
                            taskNo: 75093,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74909/',
                            description: '[Web] Video Player - add seek video event',
                            taskNo: 74909,
                        }
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/76200/',
                            description: '[Web] AAE - hide textbox when in Rework status',
                            taskNo: 76200,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/76117/',
                            description: '[Web] Vimeo Player - fix ended with pause issue',
                            taskNo: 76117,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75674/',
                            description: '[Web] Program - fix chapter timer flicker',
                            taskNo: 75674,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75651/',
                            description: '[Web] Mobile Video Player - ended and progress handling',
                            taskNo: 75651,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75593/',
                            description: '[Web] Global search input handling',
                            taskNo: 75593,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75555/',
                            description: '[Web] Mobile video player - after video ended handling',
                            taskNo: 75555,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75550/',
                            description: '[Web] Global search - module count display',
                            taskNo: 75550,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75472/',
                            description: '[Web] Mobile video player fix ended video',
                            taskNo: 75472,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75321/',
                            description: '[Web] Hot Topic - fix redirect handling for Tax a Minute and Quick Guide',
                            taskNo: 75321,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75043/',
                            description: '[Web] Program - progress not captured on change chapter',
                            taskNo: 75043,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.100',
            date: moment('2025-07-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75162/',
                            description: '[Web] Navbar - fix menu UI and size',
                            taskNo: 75162,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75147/',
                            description: '[Web] Header - fix mandarin menu UI',
                            taskNo: 75147,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/75037/',
                            description: '[Web] AAE - fix onhold status display',
                            taskNo: 75037,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.99',
            date: moment('2025-07-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74648/',
                            description: '[Web] update firebase config for uat and prod',
                            taskNo: 74648,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74646/',
                            description: '[Web] Store token in cookies',
                            taskNo: 74646,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                         {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74715/',
                            description: '[Web] clear localStorage token param on logout',
                            taskNo: 74715,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74691/',
                            description: '[Web] handle delete Cookies',
                            taskNo: 74691,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74652/',
                            description: '[Web] handle Token cookies security config',
                            taskNo: 74652,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74536/',
                            description: '[Web] Program - limit is-in-progress API request',
                            taskNo: 74536,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74447/',
                            description: '[Web] fix firebase package issue',
                            taskNo: 74447,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.98',
            date: moment('2025-07-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                         {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/73993/',
                            description: '[Web] AAE - Question - prepend to old question ID',
                            taskNo: 73993,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/73991/',
                            description: '[Web] Maintenance page',
                            taskNo: 73991,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/74138/',
                            description: '[Web] AAE - fix old question prepend character',
                            taskNo: 74138,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/73395/',
                            description: '[Web] General - support redirection after login',
                            taskNo: 73395,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/73349/',
                            description: '[Web] Live webinar should only end after Zoom ended',
                            taskNo: 73349,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/73122/',
                            description: '[Web] General - wrong language display',
                            taskNo: 73122,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72822/',
                            description: '[Web] Program - Featured Banner with language',
                            taskNo: 72822,
                        }
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.97',
            date: moment('2025-07-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72593/',
                            description: '[Web] AAE - handle richtext table UI',
                            taskNo: 72593,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72357/',
                            description: '[Web] Program - remove year filter in list view',
                            taskNo: 72357,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72236/',
                            description: '[Web] update versioning',
                            taskNo: 72236,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72049/',
                            description: '[Web] Program - update Featured program card color',
                            taskNo: 72049,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71975/',
                            description: '[Web] Course/ Webinar - unlock course UI UX enhancement',
                            taskNo: 71975,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72022/',
                            description: '[Web] Login - reset password awareness',
                            taskNo: 72022,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72647/',
                            description: '[Web] AAE - to get user latest subscription details on navigate',
                            taskNo: 72647,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72369/',
                            description: '[Web] Program - fix add to outlook calendar datetime',
                            taskNo: 72369,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72353/',
                            description: '[Web] AAE - disable textbox if remaining minutes <= 0',
                            taskNo: 72353,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/72022/',
                            description: '[Web] AAE - increase minutes not showing error if failed request',
                            taskNo: 72022,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.96',
            date: moment('2025-07-03'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71793/',
                            description: '[Web] Navbar - enhance submenu display handling',
                            taskNo: 71793,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71738/',
                            description: '[Web] AAE - update text editor',
                            taskNo: 71738,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71795/',
                            description: '[Web] Navbar - fix submenu handling',
                            taskNo: 71795,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71593/',
                            description: '[Web] AAE - hide follow up question response day',
                            taskNo: 71593,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.95',
            date: moment('2025-06-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71258/',
                            description: '[Web] Navbar special handling',
                            taskNo: 71258,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/71149/',
                            description: '[Web] Program - update progress and chapter timestamp display',
                            taskNo: 71149,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70972/',
                            description: '[Web] Program - listing and navigation enhancement',
                            taskNo: 70972,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70880/',
                            description: '[Web] AAE - hide popup working days message',
                            taskNo: 70880,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70695/',
                            description: '[Web] AAE - announcement popup',
                            taskNo: 70695,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70632/',
                            description: '[Web] Program - update copy and calendar',
                            taskNo: 70632,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70324/',
                            description: '[Web] Program - fix program UX',
                            taskNo: 70324,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68877/',
                            description: '[Web] Create password - Show at least one lowercase letter',
                            taskNo: 68877,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67590/',
                            description: '[Web] renew subscription flow',
                            taskNo: 67590,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70590/',
                            description: '[Web] Cert listing - fix listing select all display',
                            taskNo: 70590,
                        },
                         {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/70452/',
                            description: '[Web] Home - fix disable first time user journey',
                            taskNo: 70452,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/69742/',
                            description: '[Web] CSP fix - hotjar support',
                            taskNo: 69742,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/69699/',
                            description: '[Web] fix AAE success popup display logic',
                            taskNo: 69699,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/69649/',
                            description: '[Web][Prod] fix update progress interval',
                            taskNo: 69649,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68876/',
                            description: '[Web][Prod] fix update progress interval',
                            taskNo: 68876,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.95',
            date: moment('2025-06-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68708/',
                            description: '[Web] program details chapters missing issue',
                            taskNo: 68708,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.93',
            date: moment('2025-06-04'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68446/',
                            description: '[Web] User preference API integration',
                            taskNo: 68446,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68403/',
                            description: '[Web] allow skip program video',
                            taskNo: 68403,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.93',
            date: moment('2025-06-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67590/',
                            description: '[Web] renew subscription flow',
                            taskNo: 67590,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.93',
            date: moment('2025-06-03'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68217/',
                            description: '[Web] Registration - add asterisk for required field',
                            taskNo: 68217,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.92',
            date: moment('2025-05-30'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67946/',
                            description: '[Web] verify email page',
                            taskNo: 67946,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/68097/',
                            description: '[Web] update footer URLs',
                            taskNo: 68097,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.91',
            date: moment('2025-05-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67838/',
                            description: '[Web] subscription billing - add invoice url',
                            taskNo: 67838,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.91',
            date: moment('2025-05-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67649/',
                            description: '[Web] handle AAE rework status UI',
                            taskNo: 67649,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.91',
            date: moment('2025-05-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66081/',
                            description: '[Web] Enhance get attachment method, with authorization',
                            taskNo: 66081,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67533/',
                            description: '[Web] fix first time user guide',
                            taskNo: 67533,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67236/',
                            description: '[Web][Prod] add google GTM tracking code',
                            taskNo: 67236,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.91',
            date: moment('2025-05-22'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67233/',
                            description: '[Web] Optimize user active guard checking',
                            taskNo: 67233,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.90',
            date: moment('2025-05-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/67093/',
                            description: '[Web] update program listing filter',
                            taskNo: 67093,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.90',
            date: moment('2025-05-20'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66974/',
                            description: '[Web] remove associated program type for category menu items',
                            taskNo: 66974,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66897/',
                            description: '[Web] My learning - year filter is set to null or all by default',
                            taskNo: 66897,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66779/',
                            description: '[Web] update nav bar items',
                            taskNo: 66779,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.89',
            date: moment('2025-05-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66669/',
                            description: '[Web] handing for attended webinar without certificate',
                            taskNo: 66669,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.88',
            date: moment('2025-05-15'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62749/',
                            description: '[Web] enhance and optimize API query method',
                            taskNo: 62749,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.87',
            date: moment('2025-05-14'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66172/',
                            description: '[Web] Mobile player - add listener from webview',
                            taskNo: 66172,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/66080/',
                            description: '[Web] fix console error - bypass unsupport feature',
                            taskNo: 66080,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.86',
            date: moment('2025-05-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/65960/',
                            description: '[Web] mobile player - add post messages',
                            taskNo: 65960,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.85',
            date: moment('2025-05-07'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/65548/',
                            description: '[Web] add video player page for mobile app',
                            taskNo: 65548,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.85',
            date: moment('2025-05-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/65447/',
                            description: '[Web] Implement program category mandarin translation',
                            taskNo: 65447,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.85',
            date: moment('2025-05-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/65166/',
                            description: '[Web] fix walkthrough placement',
                            taskNo: 65166,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.84',
            date: moment('2025-04-30'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64849/',
                            description: '[Web] add view all button at latest course section',
                            taskNo: 64849,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.84',
            date: moment('2025-04-29'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62913/',
                            description: '[Web] if minutes < 0, the latest questions answer cant be view',
                            taskNo: 62913,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64486/',
                            description: '[Web] deeplinking in tax a minute and quick guide',
                            taskNo: 64486,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.83',
            date: moment('2025-04-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64485/',
                            description: '[Web] Program listing - stick side filter panel',
                            taskNo: 64485,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64526/',
                            description: '[Web] Program listing inconsistencies fix',
                            taskNo: 64526,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.82',
            date: moment('2025-04-25'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64359/',
                            description:
                                '[Web] course and webinar listing - anchor to result or listing section after filter',
                            taskNo: 64359,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64358/',
                            description: '[Web] update isFeatured placement',
                            taskNo: 64358,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.81',
            date: moment('2025-04-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64097/',
                            description: '[Web] to disable fast forward in vimeo player',
                            taskNo: 64097,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62914/',
                            description:
                                '[Web] Show AAE subscription near expired and AAE remaining minutes popup within X frequency',
                            taskNo: 62914,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/64097/',
                            description: '[Web] to disable fast forward in vimeo player',
                            taskNo: 64097,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.80',
            date: moment('2025-04-23'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63241/',
                            description:
                                '[Web] to block user from "submitting question" 15 calendar days before subscription end. To have a function to unbanned',
                            taskNo: 63241,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63239/',
                            description: '[Web] if user minutes is <= 0, user cannot submit question',
                            taskNo: 63239,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62915/',
                            description:
                                '[Web] When click "ask question", show a popup if user minutes is <= 15 minutes',
                            taskNo: 62915,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.80',
            date: moment('2025-04-22'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63696/',
                            description: '[Web] update classes section UI fix',
                            taskNo: 63696,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.80',
            date: moment('2025-04-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63503/',
                            description: '[Web] change all hours pill to get creditHours instead of duration',
                            taskNo: 63503,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63403/',
                            description: '[Web] Set password - include additional special characters supports',
                            taskNo: 63403,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.79',
            date: moment('2025-04-18'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63192/',
                            description: '[Prod][User Portal] Cramped "Recording Available Soon" Button in List View',
                            taskNo: 63192,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63195/',
                            description: '[Prod][User Portal] Quick Guides Submenu Does Not Change to Mandarin',
                            taskNo: 63195,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63201/',
                            description: '[Prod][User Portal] Search Bar Is Cramped with User Input',
                            taskNo: 63201,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.78',
            date: moment('2025-04-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/63018/',
                            description: '[Web] add support email in footer',
                            taskNo: 63018,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62962/',
                            description: '[Web] Subscription & Billing - display client details for all user types',
                            taskNo: 62962,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.78',
            date: moment('2025-04-16'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62898/',
                            description: '[Web] update phone number',
                            taskNo: 62898,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.78',
            date: moment('2025-04-15'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61799/',
                            description: '[Stag][User Portal] New Webinar Not Displayed in Featured Webinar Banner',
                            taskNo: 61799,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.77',
            date: moment('2025-04-11'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/62343/',
                            description: '[Web] AAE - hide admin name',
                            taskNo: 62343,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.77',
            date: moment('2025-04-10'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61498/',
                            description:
                                '[Prod][User Portal] Skeleton loader not displayed properly during course load',
                            taskNo: 61498,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.76',
            date: moment('2025-04-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61929/',
                            description: '[Web] To add Favorite button for Latest & Featured Course in Home Page',
                            taskNo: 61929,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.76',
            date: moment('2025-04-08'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61628/',
                            description: '[Web] AAE Web and Admin Portal - fix and standardize message box width',
                            taskNo: 61628,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61737/',
                            description: '[Web] Update Accounting Training Hours/CPE Hours Page',
                            taskNo: 61737,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61739/',
                            description: '[Stag][User Portal] URL Not Redirecting to Expected Page',
                            taskNo: 61739,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61714/',
                            description: '[Customer Portal] Mobile view UI bugs',
                            taskNo: 61714,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.75',
            date: moment('2025-04-07'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61493/',
                            description: '[Customer Portal] sort AAE category list',
                            taskNo: 61493,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61203/',
                            description: '[Customer Portal] refine update classes image ratio',
                            taskNo: 61203,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61463/',
                            description: '[Customer Portal] change program button copywriting',
                            taskNo: 61463,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.75',
            date: moment('2025-04-04'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61247/',
                            description: '[Customer Portal] change program details placeholder image',
                            taskNo: 61247,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/61202/',
                            description: '[Customer Portal] change slider navigation to arrow keys',
                            taskNo: 61202,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.74',
            date: moment('2025-04-03'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60965/',
                            description: '[Web] Latest/Featured courses UI changes',
                            taskNo: 60965,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60836/',
                            description: '[Prod][User Portal] Cannot Search for the Full Name of the Course',
                            taskNo: 60836,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.74',
            date: moment('2025-04-02'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60558/',
                            description: '[Prod][User Portal] Completed Button Display Instead of Progress Bar',
                            taskNo: 60558,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.74',
            date: moment('2025-03-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60355/',
                            description: 'webinar and course page - top featured list/slider should based on type',
                            taskNo: 60355,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60455/',
                            description: '[Web][User Portal] To add isFeatured filter for course and webinar listing',
                            taskNo: 60455,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.73',
            date: moment('2025-03-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60322/',
                            description: '[User Portal] Revise of My Learning page and My Certificate',
                            taskNo: 60322,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60698/',
                            description: '[Stag][User Portal] Menu Still Displays After Navigating to Another Page',
                            taskNo: 60698,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60362/',
                            description: '[UAT][User Portal] Progress Bar Not Showing 100% Despite Completing Course',
                            taskNo: 60362,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.73',
            date: moment('2025-03-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60566/',
                            description: '[Web][User Portal] Change Update Classes to be a main menu',
                            taskNo: 60566,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60354/',
                            description: 'webinar and course add query string in URL',
                            taskNo: 60354,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60560/',
                            description: '[User Portal] Program subcategory menu does not work on second click',
                            taskNo: 60560,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.72',
            date: moment('2025-03-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60351/',
                            description:
                                '[User Portal] Separate "Latest Courses" and "Featured Courses" in homepage to 2 different section',
                            taskNo: 60351,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.72',
            date: moment('2025-03-25'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60282/',
                            description: '[Prod][User Portal] Incorrect Event Order for Live Webinar',
                            taskNo: 60282,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/60286/',
                            description: '[Prod][User Portal] "Join Now" Button Not Enabled 15 Minutes Before Webinar',
                            taskNo: 60286,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59687/',
                            description:
                                '[Prod][User Portal] Total Sum of Hours and Course Hours Does Not Match Admin Portal',
                            taskNo: 59687,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59702/',
                            description: '[Prod][User Portal] Join Button Overlapping Footer in Mobile View',
                            taskNo: 59702,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.71',
            date: moment('2025-03-24'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59708/',
                            description: '[Prod][User Portal] No Spacing for "Add Card" Button in Mobile View',
                            taskNo: 59708,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59697/',
                            description: '[Prod][User Portal] Search Bar Expands in Small Screen Size',
                            taskNo: 59697,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.70',
            date: moment('2025-03-24'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59701/',
                            description: '[Stag][User Portal] Resource Menu Not Functioning in Mobile View',
                            taskNo: 59701,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.70',
            date: moment('2025-03-21'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59715/',
                            description: '[Stag][User Portal] Incorrect Copywriting for Removing Bookmark',
                            taskNo: 59715,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59772/',
                            description: '[Stag][User Portal] Misaligned Buttons in Course Cards',
                            taskNo: 59772,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59771/',
                            description: '[Stag][User Portal] Incorrect Category Tagging Display in Speakers Top Class',
                            taskNo: 59771,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59776/',
                            description: '[Stag][User Portal] Incorrect Tag Display for Courses',
                            taskNo: 59776,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.69',
            date: moment('2025-03-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59840/',
                            description: '[Web] Resize program card by ratio',
                            taskNo: 59840,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59828/',
                            description: '[Web] Program details change chapter wording',
                            taskNo: 59828,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.69',
            date: moment('2025-03-20'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59692/',
                            description: '[Stag][User Portal] Mobile Layout for Course Listing Not Displayed Correctly',
                            taskNo: 59692,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.68',
            date: moment('2025-03-20'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59662/',
                            description:
                                '[Prod][User Portal] standardize program category tags display across all pages',
                            taskNo: 59662,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.67',
            date: moment('2025-03-19'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59579/',
                            description: '[Prod][User Portal] Categories tooltip in program details page not working',
                            taskNo: 59579,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59494/',
                            description: '[Prod][User Portal] Hours Not Displayed Properly',
                            taskNo: 59494,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.66',
            date: moment('2025-03-14'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59298/',
                            description: '[Prod][User Portal] Incorrect Copywriting for Reset Email',
                            taskNo: 59298,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.65',
            date: moment('2025-03-14'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59144/',
                            description:
                                '[Prod][User Portal] Categories Not Displayed Properly for Multi-Category Courses',
                            taskNo: 59144,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59004/',
                            description: '[Prod][User Portal] Inconsistent Button Position in Webinar Section',
                            taskNo: 59004,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59155/',
                            description: '[Prod][User Portal] Registered Webinar Still Showing Register Button',
                            taskNo: 59155,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59142/',
                            description: '[Prod][User Portal] Delete Search History Dialog Too Large',
                            taskNo: 59142,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.64',
            date: moment('2025-03-12'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58891/',
                            description:
                                '[Prod][User Portal] Progress Percentage Exceeds Green Area for Double/Triple-Digit Values',
                            taskNo: 58891,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58765/',
                            description: '[Prod][User Portal]  Tutorial Box and Splash Art Misaligned',
                            taskNo: 58784,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58888/',
                            description:
                                '[Prod][User Portal] Image of Datin Shin Overlays with Tab in Mandarin Language',
                            taskNo: 58888,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58934/',
                            description:
                                '[Prod][User Portal] Unnecessary Scrollbar Appears When Only One Item is in the Table',
                            taskNo: 58934,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58930/',
                            description: '[Prod][User Portal] Incorrect Speaker Image Display',
                            taskNo: 58930,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59015/',
                            description: '[Prod][User Portal] Misalignment in List View (Mobile View)',
                            taskNo: 59015,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59008/',
                            description: '[Prod][User Portal] Misaligned Chinese Text in Language Globe (Mobile View)',
                            taskNo: 59008,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59010/',
                            description: '[Prod][User Portal] Banner Slider Icon Misaligned in Mobile View',
                            taskNo: 59010,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/59011/',
                            description: '[Prod][User Portal] Icons Not Aligned to the Top in Mobile View',
                            taskNo: 59011,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.63',
            date: moment('2025-03-11'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58652/',
                            description:
                                '[Customer Web] - Popup error message when account has been locked during login',
                            taskNo: 58652,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58784/',
                            description: '[Stag][User Portal] Global search delete button not working',
                            taskNo: 58784,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58762/',
                            description: '[Prod][User Portal] Incorrect AAE Splash Screen Display for Non-AAE Accounts',
                            taskNo: 58762,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58765/',
                            description: '[Prod][User Portal]  Tutorial Box and Splash Art Misaligned',
                            taskNo: 58765,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.62',
            date: moment('2025-03-11'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58575/',
                            description: '[Customer Web] - CR and bug fixes',
                            taskNo: 58575,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58607/',
                            description: '[Customer Portal] - Update stripe public key',
                            taskNo: 58607,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.61',
            date: moment('2025-03-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56910/',
                            description:
                                '[Admin Portal] Pentest - to display a more general error message during login',
                            taskNo: 56910,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56361/',
                            description: '[Stag][User Portal] Issues with Live to Recorded Webinar Transition',
                            taskNo: 56361,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58129/',
                            description: '[Stag][User Portal] Incorrect Icon for Download Certificate',
                            taskNo: 58129,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58193/',
                            description: '[Stag][User Portal] Null Speaker Displayed in Featured Course Listing',
                            taskNo: 58193,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58220/',
                            description: '[Stag][User Portal] Archived Speakers Visible on Course Details Page',
                            taskNo: 58220,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58515/',
                            description: '[Customer Web] - Staging Bug Fix',
                            taskNo: 58515,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.60',
            date: moment('2025-03-07'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57857/',
                            description: '[Customer Web] - Course Detail Language Option API Integration',
                            taskNo: 57857,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58129/',
                            description:
                                '[Customer Web] - Live Webinar after host ended meeting still show waiting for host to start',
                            taskNo: 58129,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.59',
            date: moment('2025-03-07'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57164/',
                            description: '[Stag][User Portal] Incorrect Button Label for Completed Course',
                            taskNo: 57164,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57484/',
                            description:
                                '[Stag][User Portal] CPE Hours Incorrectly Displayed for Courses Instead of Only Webinars',
                            taskNo: 57484,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.58',
            date: moment('2025-03-06'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/58041/',
                            description:
                                '[Stag][User Portal] User Redirected to Course Details Instead of Downloading Certificate',
                            taskNo: 58041,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57790/',
                            description: '[Stag][User Portal] No Default Image for Articles',
                            taskNo: 57790,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57795/',
                            description: '[Stag][User Portal] Multiple Scroll Bars Appearing in PDF Preview',
                            taskNo: 57795,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57804/',
                            description:
                                '[Customer Web] - Article + Speaker, redirect user to listing when details is not found',
                            taskNo: 57804,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.57',
            date: moment('2025-03-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57956/',
                            description: '[Customer Web] - add zoom link to csp',
                            taskNo: 57956,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57965/',
                            description: '[Customer Web] - Disable error popup in view-count api',
                            taskNo: 57965,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57810/',
                            description:
                                '[Stag][User Portal] Live Webinar Still Displays "Watch Now" Instead of Certificate or Completed Button',
                            taskNo: 57810,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.56',
            date: moment('2025-03-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57615/',
                            description: '[Customer Web] - Course Detail Language Option',
                            taskNo: 57615,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57611/',
                            description: '[Stag][User Portal] Tags Should Be Displayed in a Single Line',
                            taskNo: 57611,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57486/',
                            description:
                                '[Stag][User Portal] Mandarin Courses Should Be Prioritized When Switching Language from English to Mandarin',
                            taskNo: 57486,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57460/',
                            description: '[Stag][User Portal] Add Placeholder for ID',
                            taskNo: 57460,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57699/',
                            description: '[Customer Web] - Add production credentials',
                            taskNo: 57699,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.55',
            date: moment('2025-03-03'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57484/',
                            description:
                                '[Stag][User Portal] CPE Hours Incorrectly Displayed for Courses Instead of Only Webinars',
                            taskNo: 57484,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55955/',
                            description: '[Stag][User Portal] User Not Redirected to "All Classes" Details Page',
                            taskNo: 55955,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56361/',
                            description: '[Stag][User Portal] Issues with Live to Recorded Webinar Transition',
                            taskNo: 56361,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57479/',
                            description:
                                '[Stag][User Portal] Completed Classes Should Display in Integer Format Instead of Decimal',
                            taskNo: 57479,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57492/',
                            description: '[UAT][User Portal] Prompt Error on Webinar View Listing',
                            taskNo: 57492,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.54',
            date: moment('2025-02-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57131/',
                            description: '[Customer Web] - Refine the program buttons, make it a shared component',
                            taskNo: 57131,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/57164/',
                            description: '[Stag][User Portal] Incorrect Button Label for Completed Course',
                            taskNo: 57164,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56592/',
                            description: '[Stag][User Portal] No Tutorial for First-Time User Login',
                            taskNo: 56592,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.53',
            date: moment('2025-02-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56989/',
                            description: '[Customer Web] - AAE question is not related to previous inquiry UI',
                            taskNo: 56989,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56914/',
                            description:
                                '[Stag][User Portal] Error When Selecting Notification from Listing After Clicking It from Bell Icon',
                            taskNo: 56914,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56614/',
                            description: '[Stag][User Portal] First-Time User Journey Not Translated to Mandarin',
                            taskNo: 56614,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56199/',
                            description:
                                '[Stag][User Portal] "Download Certificate" Button Does Not Trigger Direct Download',
                            taskNo: 56199,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56587/',
                            description: '[Customer Web] - Change TaxPOD to taxPOD',
                            taskNo: 56587,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.53',
            date: moment('2025-02-26'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56791/',
                            description:
                                '[Customer Portal] - Program showing waiting for host when it should show the count down',
                            taskNo: 56791,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56815/',
                            description:
                                '[Stag][User Portal] Linked Question Details Not Displayed as Floating Information',
                            taskNo: 56815,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.52',
            date: moment('2025-02-25'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56393/',
                            description: '[Customer Web] - Setup nonce for inline scripts that returned from server',
                            taskNo: 56393,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54981/',
                            description:
                                '[Customer Web] - Notification to inform users when the status of AAE questions is updated.',
                            taskNo: 54981,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56603/',
                            description: '[Stag][User Portal] Webinar Search Results Do Not Show Live/Recorded Tag',
                            taskNo: 56603,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56214/',
                            description:
                                '[Stag][User Portal] Push Notification for Announcement & Other Modules Not Redirecting',
                            taskNo: 56214,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56592/',
                            description: '[Stag][User Portal] No Tutorial for First-Time User Login',
                            taskNo: 56592,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56196/',
                            description: '[Stag][User Portal] "Resume Learning" Shown for Completed Videos',
                            taskNo: 56196,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.51',
            date: moment('2025-02-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56201/',
                            description: '[Customer Web] - Revoke access token when user enter some pages',
                            taskNo: 56201,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56249/',
                            description: '[Customer Web] - Update get latest courses API call',
                            taskNo: 56249,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56180/',
                            description: '[Customer Web] Pentest - Disable and set HTTP method',
                            taskNo: 56180,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56216/',
                            description:
                                '[Stag][User Portal] Webinar Scheduled for Tomorrow Appearing in "Live Today" Section',
                            taskNo: 56216,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56211/',
                            description: '[Stag][User Portal] "Join" Wording Should Be Changed to "Register"',
                            taskNo: 56211,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56206/',
                            description: '[Stag][User Portal] Play Icon Size is Not Standardized',
                            taskNo: 56206,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56202/',
                            description:
                                '[Stag][User Portal] Course Chapter Displays Course Description Instead of Course Title',
                            taskNo: 56202,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56200/',
                            description: '[AAE] - API Integration for AAE Counter',
                            taskNo: 56200,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56358/',
                            description:
                                '[Stag][User Portal] Total Course Training Hours Should Display in Decimal Format',
                            taskNo: 56358,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.50',
            date: moment('2025-02-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55740/',
                            description: "[Customer Web] - Programs show the live gif when 'isProgress' is true",
                            taskNo: 55740,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55955/',
                            description: '[Stag][User Portal] User Not Redirected to "All Classes" Details Page',
                            taskNo: 55955,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56120/',
                            description: '[Customer Web] - Unrestricted File Upload',
                            taskNo: 56120,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/56124/',
                            description: '[Customer Web] -  Email enumeration via forgot password',
                            taskNo: 56124,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.49',
            date: moment('2025-02-20'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55144/',
                            description: '[Customer Web] - Billing & Subscription display user next plan information',
                            taskNo: 55144,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55870/',
                            description:
                                '[Customer Web] - Recorded webinar display "Did Not Attend" when user did not attended the live webinar',
                            taskNo: 55870,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55931/',
                            description: '[Customer Web] - Pagination not translated',
                            taskNo: 55931,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54905/',
                            description: '[UAT][User Portal] Default Image for Unlocked Video Is Blank',
                            taskNo: 54905,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55962/',
                            description: '[Stag][User Portal] Incorrect Confirmation Message for Drafted Question',
                            taskNo: 55962,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.48',
            date: moment('2025-02-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55601/',
                            description: '[Customer Web] - Add new device type: MobileBrowser',
                            taskNo: 55601,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55583/',
                            description: '[Customer Web] - Add Content-Security-Policy',
                            taskNo: 55583,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55842/',
                            description: '[Stag][User Portal] Remove "Q" Prefix in ID Listing',
                            taskNo: 55842,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.47',
            date: moment('2025-02-18'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55253/',
                            description:
                                '[UAT][User Portal] Subscription Expiry Pop-Up Not Displayed, Error Appears Instead',
                            taskNo: 55253,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55354/',
                            description: "[Customer Web] - Guard when user's subscription is inactive",
                            taskNo: 55354,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55217/',
                            description: '[Customer Web] - AAE add question ID in listing and details',
                            taskNo: 55217,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55682/',
                            description: '[Customer Web] - Update rich editor plugin',
                            taskNo: 55682,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55601/',
                            description: '[Customer Web] - Add new device type: MobileBrowser',
                            taskNo: 55601,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.46',
            date: moment('2025-02-18'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55352/',
                            description: '[Customer Web] - Add loading skeleton for all pages',
                            taskNo: 55352,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55697/',
                            description: '[Customer Portal] - Add x-ms-blob-content-type to azure blob service',
                            taskNo: 55697,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54183/',
                            description: '[Stag][User Portal] Some Content Not Translated to Mandarin',
                            taskNo: 54183,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44552/',
                            description:
                                '[Stag][User Portal] Show Live Status Only for Webinars Scheduled Within the Next 14 Days',
                            taskNo: 44552,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55639/',
                            description: '[Stag][User Portal] Live Animation Displayed Before Actual Start Time',
                            taskNo: 55639,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55249/',
                            description: '[UAT][User Portal] Global Search Term Not Cleared After Navigation',
                            taskNo: 55249,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55633/',
                            description: '[Stag][User Portal] Calendar View Displays Incorrect Start and End Time',
                            taskNo: 55633,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.45',
            date: moment('2025-02-17'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55249/',
                            description: '[UAT][User Portal] Global Search Term Not Cleared After Navigation',
                            taskNo: 55249,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54172/',
                            description: '[Stag][User Portal] Insufficient Padding in Language Category',
                            taskNo: 54172,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53733/',
                            description: '[Stag][User Portal] Language Changes to English After Login',
                            taskNo: 53733,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55039/',
                            description: '[UAT][User Portal] Missing Category and Action Information',
                            taskNo: 55039,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.44',
            date: moment('2025-02-14'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55361/',
                            description:
                                '[Customer Web] - Program listing filter, separate out date filter to a new section',
                            taskNo: 55361,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.44',
            date: moment('2025-02-13'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55247/',
                            description: '[UAT][User Portal] E-Invoicing Filter Not Updated in Sidebar',
                            taskNo: 55247,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55306/',
                            description: '[Customer Web] - Login Error message always showing wrong password popup',
                            taskNo: 55306,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55137/',
                            description: '[Customer Web] - 404 Page not found',
                            taskNo: 55137,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.43',
            date: moment('2025-02-13'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55203/',
                            description: '[Customer Web] - Add no follow tag',
                            taskNo: 55203,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55146/',
                            description: '[UAT][User Portal] Customer Support Number Should Redirect to WhatsApp',
                            taskNo: 55146,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55148/',
                            description:
                                '[UAT][User Portal] Incorrect Icon Size & Course Title Should Be Limited to One Line',
                            taskNo: 55148,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.43',
            date: moment('2025-02-12'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55022/',
                            description: '[Customer Web] - Popup message UI when user logged in from another device',
                            taskNo: 55022,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55144/',
                            description: '[Customer Web] - Billing & Subscription display user next plan information',
                            taskNo: 55144,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55056/',
                            description: '[UAT][User Portal] The Page Should Redirect to Series Details Page',
                            taskNo: 55056,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55055/',
                            description: '[UAT][Customer Web] "Allow Download Material Before Enroll" Not Working',
                            taskNo: 55055,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55109/',
                            description:
                                '[Customer Web] - After click mark notification as read, the indicator for notification does not reflected',
                            taskNo: 55109,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55130/',
                            description: '[Customer Web] - AAE page will goes to blank page when refresh',
                            taskNo: 55130,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.43',
            date: moment('2025-02-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54914/',
                            description: '[UAT][User Portal] Bulk Download Checkbox Not Selecting All',
                            taskNo: 54914,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54858/',
                            description: '[Customer Web] - Course hide progress bar when there is no videos available',
                            taskNo: 54858,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55045/',
                            description: '[UAT][User Portal] Resume Learning Position Overlaps Footer',
                            taskNo: 55045,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55022/',
                            description: '[Customer Web] - Popup message UI when user logged in from another device',
                            taskNo: 55022,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54914/',
                            description: '[UAT][User Portal] Bulk Download Checkbox Not Selecting All',
                            taskNo: 54914,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54905/',
                            description: '[UAT][User Portal] Default Image for Unlocked Video Is Blank',
                            taskNo: 54905,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/55046/',
                            description: '[UAT][User Portal] Add More Shadow to "Resume Learning" Section',
                            taskNo: 55046,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.43',
            date: moment('2025-02-07'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54902/',
                            description: '[UAT][User Portal] Search Function Not Working on First Attempt',
                            taskNo: 54902,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54903/',
                            description: '[UAT][User Portal] Speaker Details Not Fetched Correctly',
                            taskNo: 54903,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54908/',
                            description:
                                '[UAT][User Portal] Join Webinar Button Should Be Enabled 15 Minutes Before Start',
                            taskNo: 54908,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.42',
            date: moment('2025-02-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54672/',
                            description: '[Customer Web] - Integrate video views count API',
                            taskNo: 54672,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54729/',
                            description: '[Customer Web] - Update Program View Count API Integration',
                            taskNo: 54729,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54730/',
                            description: '[Customer Web] - Update Article View Count API Integration',
                            taskNo: 54730,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54731/',
                            description: '[Customer Web] - Guide Update View Count API Integration',
                            taskNo: 54731,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54732/',
                            description: '[Customer Web] - Update Tax A Minute View Count API Integration',
                            taskNo: 54732,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.42',
            date: moment('2025-02-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54412/',
                            description: '[Customer Portal] - Integrate multi-language dropdown API',
                            taskNo: 54412,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54703/',
                            description: '[Customer Web] [Staging] - Update production key',
                            taskNo: 54703,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54572/',
                            description: '[Stag][User Portal] Language Dropdown Does Not Match Admin Portal Listing',
                            taskNo: 54572,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.41',
            date: moment('2025-02-05'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54661/',
                            description:
                                '[Customer Web] - [Stag][User Portal] Hyperlinks in Resource Page Not Redirecting Correctly',
                            taskNo: 54661,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.40',
            date: moment('2025-02-05'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54618/',
                            description: '[Customer Web] - Registration plan styling issue',
                            taskNo: 54618,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.39',
            date: moment('2025-02-04'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54411/',
                            description:
                                '[Customer Web] - Filtering does remain the options user selected when user click back button',
                            taskNo: 54411,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54187/',
                            description: '[Stag][User Portal] Unable to Follow Up on Current Conversation',
                            taskNo: 54187,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54185/',
                            description:
                                '[Stag][User Portal] Users Without AAE Product Purchase Can Still Send Messages in AAE Module',
                            taskNo: 54185,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54186/',
                            description: '[Stag][User Portal] No Data Found When Filtering by Date Range',
                            taskNo: 54186,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.38',
            date: moment('2025-02-03'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54177/',
                            description: '[Stag][User Portal] Unable to Perform Bulk Download',
                            taskNo: 54177,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54179/',
                            description: '[Stag][User Portal] Unable to Download Certificate from My Certificate Page',
                            taskNo: 54179,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54174/',
                            description: '[Stag][User Portal] Double Click Required to Navigate to Description',
                            taskNo: 54174,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54178/',
                            description: '[Stag][User Portal] Selected Year Not Reflected in Dropdown Placeholder',
                            taskNo: 54178,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54211/',
                            description:
                                '[Customer Web] - AAE: Customer should not able to submit question during Follow Up status',
                            taskNo: 54211,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53733/',
                            description: '[Stag][User Portal] Language Changes to English After Login',
                            taskNo: 53733,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50822/',
                            description: '[Stag][User Portal] Category Sync Issue Between User Portal and Admin Portal',
                            taskNo: 50822,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52059/',
                            description:
                                '[Stag][UAT][User Portal] Speaker image and name in Courses/Webinars should be clickable and redirect to speaker details page',
                            taskNo: 52059,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54173/',
                            description: '[Stag][User Portal] Incorrect Category Displayed for Courses',
                            taskNo: 54173,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54172/',
                            description: '[Stag][User Portal] Insufficient Padding in Language Category',
                            taskNo: 54172,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51446/',
                            description: '[Stag][UAT][User Portal] Incorrect Status After Manager Submission',
                            taskNo: 51446,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54176/',
                            description: '[Stag][User Portal] Percentage Bar Spacing Not Consistent',
                            taskNo: 54176,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51816/',
                            description: '[User Portal] Revise all time to use 12 hours format',
                            taskNo: 51816,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54170/',
                            description: '[Stag][User Portal] Multiple Clicks Needed to Close Session Expired Message',
                            taskNo: 54170,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54326/',
                            description: '[Customer Portal] - Navbar changing program topic bug',
                            taskNo: 54326,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.37',
            date: moment('2025-01-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50857/',
                            description:
                                '[Stag][User Portal] Plugin Setting in Preview and Maintain Preview in a Separate Tab',
                            taskNo: 50857,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52300/',
                            description: '[Customer Web] - API Integration for unique link',
                            taskNo: 52300,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51051/',
                            description: '[Customer Web] - Remove billing card for auto subscription API Integration',
                            taskNo: 51051,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51050/',
                            description: '[Customer Web] - Add billing card for auto subscription API Integration',
                            taskNo: 51050,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51048/',
                            description: '[Customer Web] - Update billing card for auto subscription API Integration',
                            taskNo: 51048,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/54027/',
                            description: 'Bug 54027: [Customer Web] - Change planeId to planId',
                            taskNo: 54027,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.36',
            date: moment('2025-01-22'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53479/',
                            description: '[Customer Web] - AAE Module sync the newest status with BE',
                            taskNo: 53479,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53802/',
                            description: '[Customer Web] - Add images for email template',
                            taskNo: 53802,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53484/',
                            description:
                                '[Customer Portal] - Routing strategy during change language + Language accept header',
                            taskNo: 53484,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.36',
            date: moment('2025-01-22'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51446/',
                            description: '[Stag][UAT][User Portal] Incorrect Status After Manager Submission',
                            taskNo: 51446,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.36',
            date: moment('2025-01-21'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52025/',
                            description:
                                '[Stag][UAT][User Portal] Change My Favourites icon to heart shape to ensure consistency',
                            taskNo: 52025,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52086/',
                            description:
                                '[Stag][UAT][User Portal] Revise design and wording in Subscription & Billing page',
                            taskNo: 52086,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51047/',
                            description: '[Customer Web] - Add billing card for auto subscription UI',
                            taskNo: 51047,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.35',
            date: moment('2025-01-20'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/53212/',
                            description:
                                '[Customer Web] - Navigation Bar, redirect user to related page when clicked rather than expand menu',
                            taskNo: 53212,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52594/',
                            description:
                                '[Customer Web] - [UAT][Stag][User Portal] "Remember Me" Function Not Working in User Portal',
                            taskNo: 52594,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52962/',
                            description:
                                '[Customer Web] - Calendar listing, today button not working as expected as live webinar UI might not has loaded in the listing',
                            taskNo: 52962,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52765/',
                            description:
                                "[Customer Portal] - Notification Listing Infinite scroll got issue, redirection haven't implemented, mark all notification cannot be use",
                            taskNo: 52765,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52050/',
                            description:
                                '[Stag][UAT][User Portal] Does not scroll back to top after apply or unapply filter',
                            taskNo: 52050,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.34',
            date: moment('2025-01-17'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52548/',
                            description: '[UAT][User Portal] E-Certificate Not Available After Course Completion',
                            taskNo: 52548,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52051/',
                            description:
                                '[Stag][UAT][User Portal] Click on Class Materials, not redirect to the class material section',
                            taskNo: 52051,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.34',
            date: moment('2025-01-16'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52076/',
                            description: '[Stag][UAT][User Portal] Font style for "Remember Me" is different',
                            taskNo: 52076,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52081/',
                            description: '[Stag][UAT][User Portal] Revise the colour of title and time to #231F20',
                            taskNo: 52081,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52771/',
                            description:
                                '[Stag][User Portal] Video Does Not Play Automatically After Clicking "Watch Now"',
                            taskNo: 52771,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52595/',
                            description: '[UAT][Stag][User Portal] Language Change: CH Should Display as 中文',
                            taskNo: 52595,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51040/',
                            description: '[Customer Web] - Journey Flow API Integration',
                            taskNo: 51040,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51401/',
                            description: 'Link E-Invoicing category to the navigation bar',
                            taskNo: 51401,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.33',
            date: moment('2025-01-15'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52030/',
                            description:
                                '[Stag][UAT][User Portal] Dropdown does not close and search item is not remove after user click on a hot topic',
                            taskNo: 52030,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52028/',
                            description: '[Stag][UAT][User Portal] Cancel button does not remove current search item',
                            taskNo: 52028,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52082/',
                            description: '[Stag][UAT][User Portal] Fix the padding of the cards',
                            taskNo: 52082,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52026/',
                            description: '[Stag][UAT][User Portal] Change email address to support@taxpod.my',
                            taskNo: 52026,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51539/',
                            description: '[Stag][UAT][User Portal] Register button should be hidden for past webinar',
                            taskNo: 51539,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51783/',
                            description: '[Stag][UAT][User Portal] Webinar record not being filtered',
                            taskNo: 51783,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52023/',
                            description:
                                '[Stag][UAT][User Portal] Should logout user from the account after update password successfully',
                            taskNo: 52023,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52022/',
                            description: '[Stag][UAT][User Portal] At least one uppercase letter, not lowercase letter',
                            taskNo: 52022,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52092/',
                            description:
                                '[Stag][UAT][User Portal] Tax A Minute from search not displayed in full and source link not displayed',
                            taskNo: 52092,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52034/',
                            description: '[Stag][UAT][User Portal] No count for number of items in course page',
                            taskNo: 52034,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52747/',
                            description: '[Stag][User Portal] Course Completion Requires Watching Video Twice',
                            taskNo: 52747,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51769/',
                            description: '[Stag][UAT][User Portal] Results that are returned is duplicated',
                            taskNo: 51769,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51800/',
                            description:
                                '[Stag][UAT][User Portal] CPE hours and learning progress not displayed correctly',
                            taskNo: 51800,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52231/',
                            description:
                                '[Stag][UAT][User Portal] Result page always land at the middle section of the page for webinar calendar and article',
                            taskNo: 52231,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.32',
            date: moment('2025-01-14'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51539/',
                            description: '[Stag][UAT][User Portal] Register button should be hidden for past webinar',
                            taskNo: 51539,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51769/',
                            description: '[Stag][UAT][User Portal] Results that are returned is duplicated',
                            taskNo: 51769,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52054/',
                            description:
                                '[Stag][UAT][User Portal] Button, time length, chapter minutes displayed incorrect',
                            taskNo: 52054,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52229/',
                            description:
                                '[Stag][UAT][User Portal] Video has been completed watched but it still there under ongoing tab',
                            taskNo: 52229,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52053/',
                            description:
                                '[Stag][UAT][User Portal]Autoplay to next video, but next video load but does not autoplay',
                            taskNo: 52053,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52064/',
                            description:
                                '[Stag][UAT][User Portal] Speakers details page, Top Classes titles are all not clickable',
                            taskNo: 52064,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51812/',
                            description:
                                '[Stag][UAT][User Portal] Date incorrect, Category not displayed, click on Invoice / Receipt redirect to home page',
                            taskNo: 51812,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52055/',
                            description:
                                '[Stag][UAT][User Portal] Tags not working in Articles, Quick Guide, Tax A Minute',
                            taskNo: 52055,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.31',
            date: moment('2025-01-13'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51849/',
                            description: '[Customer Web] - Journey Flow Mobile UI',
                            taskNo: 51849,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51432/',
                            description:
                                '[Customer Web] [Stg] - Incorrect url params + filtering not working when clicking from navbar',
                            taskNo: 51432,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52061/',
                            description:
                                '[Stag][UAT][User Portal]All speaker top classes link not working, click on it redirect to home page',
                            taskNo: 52061,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/52175/',
                            description: '[Customer Web] [Stg] - Mobile view menu UI need to be refine',
                            taskNo: 52175,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.31',
            date: moment('2025-01-10'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48745/',
                            description: '[Stag][User Portal] Hover Over Title to Show Full Sentence',
                            taskNo: 48745,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.30',
            date: moment('2025-01-09'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51073/',
                            description: '[Stag][User Portal] Search Result Count Is Displayed Incorrectly',
                            taskNo: 51073,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51739/',
                            description: '[Customer Web] [Stg] - Calendar program popup overlay with navbar',
                            taskNo: 51739,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51433/',
                            description: '[Stag][UAT][User Portal] Users Cannot Follow Up on Previous Questions',
                            taskNo: 51433,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47085/',
                            description: '[Stag][User Portal] Reset Password Link Validity Exceeds Limit',
                            taskNo: 47085,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.30',
            date: moment('2025-01-08'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50854/',
                            description:
                                '[Stag][User Portal] Revision of Speaker Qualification Text Format in Speaker Detail Page',
                            taskNo: 50854,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51039/',
                            description: '[Customer Web] - Journey Flow UI',
                            taskNo: 51039,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.29',
            date: moment('2025-01-07'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50865/',
                            description:
                                '[Stag][User Portal] Standardize TaxPOD Fee & Amount in Subscription and Billing',
                            taskNo: 50865,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50866/',
                            description: '[Stag][User Portal] Revise Pagination in Subscription',
                            taskNo: 50866,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51220/',
                            description: '[Customer Web] [UAT] - Video resume feature not working',
                            taskNo: 51220,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51247/',
                            description: '[Customer Web] [UAT] - Class material missing placeholder for no records',
                            taskNo: 51247,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51243/',
                            description: '[Customer Web] [UAT] - Speaker Listing Duplicated',
                            taskNo: 51243,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51220/',
                            description: '[Customer Web] [UAT] - Video resume feature not working',
                            taskNo: 51220,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.29',
            date: moment('2025-01-06'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50860/',
                            description:
                                '[Stag][User Portal] Minus the Source Title in "Tax a Minutes" & Revise Font Color',
                            taskNo: 50860,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50863/',
                            description:
                                '[Stag][User Portal] Add Padding in Course Detail Page for "About the Class" and "Class Material" Sections',
                            taskNo: 50863,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50864/',
                            description: '[Stag][User Portal] Wrong Spelling for Notification Label',
                            taskNo: 50864,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.28',
            date: moment('2025-01-07'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/51244/',
                            description:
                                '[Customer Web] [UAT] - Video progress bar in my learning not working properly',
                            taskNo: 51244,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.28',
            date: moment('2025-01-03'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50945/',
                            description: '[User Portal] Notification listing type fix',
                            taskNo: 50945,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50969/',
                            description: '[User Portal] Header and footer adjustments',
                            taskNo: 50969,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50849/',
                            description: '[Stag] Placeholder Design for Empty Speaker Section',
                            taskNo: 50849,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50852/',
                            description: '[Stag][User Portal] Placeholder for Missing Top Class in Speaker Detail Page',
                            taskNo: 50852,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50851/',
                            description: '[Stag][User Portal] Article Display Limit on Home Page',
                            taskNo: 50851,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50862/',
                            description:
                                '[Stag][User Portal] Different Placeholder for Certificate Page If No Certificate Available',
                            taskNo: 50862,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.27',
            date: moment('2025-01-02'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50642/',
                            description:
                                '[Stag] [User Portal] To revise the mobile phone image in mobile view >> add padding',
                            taskNo: 50642,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50640/',
                            description:
                                '[Stag] To add the number of course and course minutes in series card in home page',
                            taskNo: 50640,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50638/',
                            description: '[Stag] To fix the padding of the webinar calendar listing card',
                            taskNo: 50638,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48731/',
                            description: '[Stag][User Portal] Missing Sorting Icon in Title Tab',
                            taskNo: 48731,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48742/',
                            description: '[Stag][User Portal] Long Sentence Overflow Should Be Truncated with Ellipsis',
                            taskNo: 48742,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48732/',
                            description: '[Stag][User Portal] Date Digits Cut Off in Date Picker',
                            taskNo: 48732,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48739/',
                            description: '[Stag][User Portal] Missing Mouse Icon on Hover for Date Picker',
                            taskNo: 48739,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50822/',
                            description: '[Stag][User Portal] Category Sync Issue Between User Portal and Admin Portal',
                            taskNo: 50822,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.27',
            date: moment('2024-12-31'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50636/',
                            description: '[Stag] Revise the footer >> add YYC + remove Powered by YYC',
                            taskNo: 50636,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50641/',
                            description: '[Stag] To change the view all article button to top right',
                            taskNo: 50641,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48759/',
                            description:
                                '[Customer Web] - Default Image Should Be Displayed If Consultant/Manager Has No Profile Picture',
                            taskNo: 50253,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48756/',
                            description: '[Stag][User Portal] Missing Title in the Details Section',
                            taskNo: 48756,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47301/',
                            description: '[Stag][User Portal] Inconsistent Design for Removing Favorite Course',
                            taskNo: 47301,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47083/',
                            description: '[Stag][User Portal] Remember Me Functionality Not Working',
                            taskNo: 47083,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47401/',
                            description: '[Stag][User Portal] Description Format Mismatch',
                            taskNo: 47401,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.27',
            date: moment('2024-12-30'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50253/',
                            description: '[Customer Web] - Update mandarin translation',
                            taskNo: 50253,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50356/',
                            description: '[Customer Web] On Hold status update for question listing',
                            taskNo: 50356,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.27',
            date: moment('2024-12-27'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44496/',
                            description:
                                '[Stag][User Portal] Verify Alignments and Font Sizes Across Browsers and Screen Sizes',
                            taskNo: 44496,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.26',
            date: moment('2024-12-27'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/50130/',
                            description: '[Stag][User Portal] Clients feedback on UI',
                            taskNo: 50130,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.26',
            date: moment('2024-12-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48971/',
                            description: '[Customer Web] - API Integration for export excel API',
                            taskNo: 48971,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44549/',
                            description: '[Stag][User Portal] Session Expiry Popup Requires Multiple Clicks to Close',
                            taskNo: 44549,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.26',
            date: moment('2024-12-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48355/',
                            description: '[Customer Web] -  Header notification indicator API Integration',
                            taskNo: 48355,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48358/',
                            description: '[Customer Web] - Notification Listing API Integration',
                            taskNo: 48358,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.26',
            date: moment('2024-12-23'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48346/',
                            description: '[Customer Web] - Header search API integration (Tags)',
                            taskNo: 48346,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48357/',
                            description: '[Customer Web] - Notification Listing UI',
                            taskNo: 48357,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.26',
            date: moment('2024-12-20'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48350/',
                            description: '[Customer Web] - Global Search API Integration',
                            taskNo: 48350,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.25',
            date: moment('2024-12-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48360/',
                            description: '[Customer Web] - Header language selection UI',
                            taskNo: 48360,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48347/',
                            description: '[Customer Web] - Header search topic API integration',
                            taskNo: 48347,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48757/',
                            description: '[Stag][User Portal] Ask Question Title Should Be Centered',
                            taskNo: 48757,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.25',
            date: moment('2024-12-18'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46903/',
                            description: '[Customer Web] - Course Details: In the end of video, auto select next video',
                            taskNo: 46903,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48784/',
                            description: '[Stag][User Portal] Missing Prompt Message After Submitting the Question',
                            taskNo: 48784,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48762/',
                            description:
                                '[Stag][User Portal] Error Message for File Size Limit Should Display Every Time User Uploads a Large File',
                            taskNo: 48762,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.25',
            date: moment('2024-12-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46917/',
                            description: '[Customer Web] - Course Details: API Integration for chapter progress',
                            taskNo: 46917,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46916/',
                            description: '[Customer Web] - Course Details: API Integration for progress',
                            taskNo: 46916,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-17'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48787/',
                            description: '[Stag][User Portal] Save as Draft and Submit Buttons Not Disabled Initially',
                            taskNo: 48787,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-16'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45569/',
                            description: '[Customer Web] - API Integration for bulk download',
                            taskNo: 45569,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48575/',
                            description: '[Customer Web] - Registration: Integrate Payment Gateway',
                            taskNo: 48575,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48356/',
                            description: '[Customer Web] - Header notification listing UI',
                            taskNo: 48356,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43883/',
                            description: '[Customer Web] - Rate Us Api Integration',
                            taskNo: 43883,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43893/',
                            description: '[Customer Web] - Download PDF API Integration',
                            taskNo: 43893,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-12'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48348/',
                            description: '[Customer Web] - Global Search listing UI',
                            taskNo: 48348,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48343/',
                            description: '[Customer Web] - Header search dropdown UI',
                            taskNo: 48343,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48208/',
                            description:
                                '[Customer Web] - Enable or Disable the topic selection based on the program type selected',
                            taskNo: 48208,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/48141/',
                            description: '[Customer Web] - Banner add auto slide after 5sec',
                            taskNo: 48141,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.24',
            date: moment('2024-12-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43341/',
                            description: '[Customer Web] - Refine the function of the filtering add Date',
                            taskNo: 43341,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.23',
            date: moment('2024-12-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43341/',
                            description: '[Customer Web] - Refine the function of the filtering add Date',
                            taskNo: 43341,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.22',
            date: moment('2024-12-03'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46919/',
                            description: '[Customer Web] - Program Card: Refine progress bar UI',
                            taskNo: 46919,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44552/',
                            description:
                                '[Stag][User Portal] Show Live Status Only for Webinars Scheduled Within the Next 14 Days',
                            taskNo: 44552,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46322/',
                            description: '[Stag][User Portal] Button and Search Input Width Misalignment',
                            taskNo: 46322,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46320/',
                            description: '[Stag][User Portal] Tabs Alignment and Border Issue',
                            taskNo: 46320,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46318/',
                            description: '[Stag][User Portal] Incorrect Spelling for Ongoing',
                            taskNo: 46318,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46317/',
                            description: '[Stag][User Portal] Missing Clear Icon in Search Input',
                            taskNo: 46317,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43881/',
                            description: '[Customer Web] - AAE: Rate US Popup UI',
                            taskNo: 43881,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44535/',
                            description: '[Stag][User Portal] No Padding at Notification Badge',
                            taskNo: 44535,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.22',
            date: moment('2024-12-03'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43881/',
                            description: '[Customer Web] - AAE: Rate US Popup UI',
                            taskNo: 43881,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.21',
            date: moment('2024-12-02'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47383/',
                            description: '[Customer Web] - Pass device information during login',
                            taskNo: 47383,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46911/',
                            description: '[Customer Web] - AAE Send Question Respond API Integration',
                            taskNo: 46911,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43886/',
                            description: '[Customer Web] - View Message Api Integration',
                            taskNo: 43886,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/47072/',
                            description: '[Customer Web] - AAE: Increate Minutes API Integration',
                            taskNo: 47072,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43536/',
                            description: '[Stag][User Portal] Speaker Image Display Issue',
                            taskNo: 43536,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.21',
            date: moment('2024-11-29'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46899/',
                            description: '[Customer Web] - AAE Continue Draft Questions API Integration',
                            taskNo: 46899,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.20',
            date: moment('2024-11-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45402/',
                            description: '[Customer Web] - Feature series listing API integration',
                            taskNo: 45402,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43939/',
                            description: '[Customer Web] AAE - Increase Minutes Popup',
                            taskNo: 43939,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/46915/',
                            description: '[Customer Web] - Home page refine UI for feature/latest course section',
                            taskNo: 46915,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.20',
            date: moment('2024-11-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42091/',
                            description: '[Web] - AEE Dashboard API integration',
                            taskNo: 42091,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43890/',
                            description: '[Customer Web] - AAE Create Question API Integration',
                            taskNo: 43890,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.19',
            date: moment('2024-11-25'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45401/',
                            description: '[Web] - Feature series listing UI',
                            taskNo: 45401,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.19',
            date: moment('2024-11-21'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43514/',
                            description:
                                '[Stag][User Portal] Course Information Layout in List View Does Not Match Design',
                            taskNo: 43514,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43588/',
                            description: '[Stag][User Portal] Gap Between Title and Date Not Aligned with Figma Design',
                            taskNo: 43588,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.18',
            date: moment('2024-11-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42086',
                            description: '[WEB] - AAE Listing Top Information UI',
                            taskNo: 42086,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42088',
                            description: '[WEB] - AAE listing UI',
                            taskNo: 42088,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42097',
                            description: '[WEB] - Ask Expert UI',
                            taskNo: 42097,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44518/',
                            description: '[Stag][User Portal] Page "Blinks" When Switching Views',
                            taskNo: 44518,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44534/',
                            description: '[Stag][User Portal] Missing Hover Effect for Download Materials Section',
                            taskNo: 44534,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43638/',
                            description:
                                '[Stag][User Portal] "Shortcut to Top" Button Positioned Too Far from Bottom of Page in Mobile View',
                            taskNo: 43638,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44523/',
                            description: '[Stag][User Portal] "Hover State Styling for Menu Items',
                            taskNo: 44523,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44522/',
                            description: '[Stag][User Portal] Checkbox Colors Do Not Match Figma Design',
                            taskNo: 44522,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.17',
            date: moment('2024-11-20'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45158',
                            description: '[Web] Certificate Listing API Integration',
                            taskNo: 45158,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38542',
                            description: '[Web] Subscription and Billing - API Integration for Subscription Details',
                            taskNo: 38542,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45301',
                            description: '[Web] Billing History API Integration (Split out)',
                            taskNo: 45301,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43335/',
                            description: '[Stag][User Portal] Missing Date Title in Calendar List View',
                            taskNo: 43335,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44500/',
                            description: '[Stag][User Portal] Remove Border Radius for Selected Tab and Adjust Styling',
                            taskNo: 44500,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44537/',
                            description:
                                '[Stag][User Portal] Title Spelling Mismatch Between Content Area and Left Navigation',
                            taskNo: 44537,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44543/',
                            description: '[Stag][User Portal] Next and Previous Buttons for All Series Not Functioning',
                            taskNo: 44543,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.16',
            date: moment('2024-11-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45157',
                            description: '[Stag][User Portal] Certificate Listing UI',
                            taskNo: 45157,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/45388/',
                            description: '[Stag][User Portal] My Learning integrate status counter API',
                            taskNo: 45388,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44524/',
                            description:
                                '[Stag][User Portal] Font Color for Profile Details Does Not Match Figma Design',
                            taskNo: 44524,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43335/',
                            description: '[Stag][User Portal] Missing Date Title in Calendar List View',
                            taskNo: 43335,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.15',
            date: moment('2024-11-18'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44537',
                            description:
                                '[Stag][User Portal] Title Spelling Mismatch Between Content Area and Left Navigation',
                            taskNo: 44537,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44539/',
                            description:
                                '[Stag] [User Portal] Misaligned Navigation in Main Banner and Unselected Item Color Issue',
                            taskNo: 44539,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44536/',
                            description:
                                'Bug 44536: [Stag][User Portal] Center Month and Align Left/Right Icons Beside It in Calendar',
                            taskNo: 44536,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.15',
            date: moment('2024-11-15'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44553/',
                            description: '[Stag][User Portal] Missing Shadow Behind the Card Popup for Webinar Details',
                            taskNo: 44553,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38522',
                            description: '[Web] General - Profile Drop Down Menu API Integration',
                            taskNo: 38522,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43907',
                            description: '[Web] User details - API Integration',
                            taskNo: 43907,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44266',
                            description: '[Web] - Refine the speaker card UI',
                            taskNo: 44266,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38546',
                            description: '[Web] - Profile Details UI',
                            taskNo: 38546,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38548',
                            description: '[Web] - API Integration for Details and Update Password',
                            taskNo: 38548,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43914',
                            description: '[Web] - Change Password - Change Password UI',
                            taskNo: 43914,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43915',
                            description: '[Web] - Change Password- Change Password API Integration',
                            taskNo: 43915,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44606',
                            description: '[Web] - Upcoming live webinar in homepage missing spacing',
                            taskNo: 44606,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44541/',
                            description: '[Stag][User Portal] Speaker Change Overlaps with Details',
                            taskNo: 44541,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.14',
            date: moment('2024-11-14'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38538',
                            description: '[Web] Subscription and Billing - Details Page UI',
                            taskNo: 38538,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44466/',
                            description: '[Web] - Mobile view for menu didnt close when redirecting to new URL',
                            taskNo: 44466,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/44467',
                            description:
                                '[Web] - Mobile view for calendar popup did not close after redirect to the details page',
                            taskNo: 44467,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.14',
            date: moment('2024-11-13'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43633',
                            description: '[Stag][User Portal] Banner Height Disproportionate in Mobile View',
                            taskNo: 43633,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43536',
                            description: '[Stag][User Portal] Speaker Image Display Issue',
                            taskNo: 43536,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43514',
                            description:
                                '[Stag][User Portal] Course Information Layout in List View Does Not Match Design',
                            taskNo: 43514,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43542',
                            description: '[Stag][User Portal]  Course/Webinar Image Not Updated from Admin Input',
                            taskNo: 43542,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43430',
                            description: '[Stag][User Portal]  Missing Category Tag and Introduction in Course Display',
                            taskNo: 43430,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43556',
                            description: '[Stag][User Portal] Missing Speaker Image (Default Image Needed)',
                            taskNo: 43556,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43552',
                            description: '[Stag][User Portal] Incomplete Course Information in Featured Series',
                            taskNo: 43552,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.13',
            date: moment('2024-11-12'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43422',
                            description: '[WEB] Validation Error Message Lacks Field-Specific Information',
                            taskNo: 43422,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43434',
                            description: '[WEB] Latest Course Not Displayed Based on Creation Date',
                            taskNo: 43434,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43437',
                            description: '[WEB] Missing Category Tags and Introduction for Latest Course in Listing',
                            taskNo: 43437,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43635',
                            description: '[WEB] Course Display Overcrowded in Mobile View',
                            taskNo: 43635,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.13',
            date: moment('2024-11-11'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43631',
                            description: '[WEB] Back Button Overlaps with Title in Mobile View',
                            taskNo: 43631,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43426',
                            description: '[WEB] Inconsistent Speaker Layout Display',
                            taskNo: 43426,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43548',
                            description: '[WEB] Missing Class Duration Display',
                            taskNo: 43548,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43454',
                            description: '[WEB] Shortcuts to Top Button Missing on Non-Home Page',
                            taskNo: 43454,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43547',
                            description: '[WEB] Missing "Add to My Favorites" Button in Upcoming Class Display',
                            taskNo: 43547,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43503',
                            description: '[WEB] Missing "No Results/No Data Found" Message',
                            taskNo: 43503,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43606',
                            description: '[Web] Speaker listing UI',
                            taskNo: 43606,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43607',
                            description: '[Web] Speaker listing API integration',
                            taskNo: 43607,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/436068',
                            description: '[Web] Speaker Details UI',
                            taskNo: 43608,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43609',
                            description: '[Web] Speaker Details API integration',
                            taskNo: 43609,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.13',
            date: moment('2024-11-08'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43586',
                            description: '[WEB] Add release version number in footer',
                            taskNo: 43586,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43324',
                            description: '[WEB] Unable to View Webinar Details When Scrolling Within Calendar',
                            taskNo: 43324,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.12',
            date: moment('2024-11-07'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42391',
                            description: '[WEB] Tax a minute UI',
                            taskNo: 42391,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42393',
                            description: '[WEB] Quick Guide UI',
                            taskNo: 42393,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42394',
                            description: '[WEB] Quick Guide API integration',
                            taskNo: 42394,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42392',
                            description: '[WEB] tax a minute API integration',
                            taskNo: 42392,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43339',
                            description: '[WEB] Refine UI and integrate API for Course + Webinar menu',
                            taskNo: 43339,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42080',
                            description: '[WEB] tax a minute API integration',
                            taskNo: 42080,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42081',
                            description: '[WEB] - Article details you may also like UI',
                            taskNo: 42081,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42068',
                            description: '[WEB] - Article Listing API Integration',
                            taskNo: 42068,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42066',
                            description: '[WEB] - Article listing UI',
                            taskNo: 42066,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42079',
                            description: '[WEB] - Article details page UI',
                            taskNo: 42079,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43530',
                            description: '[WEB] - Internal demo bugs',
                            taskNo: 43530,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43322',
                            description: '[Web] - To add confirmation popup for user who failed register live webinar',
                            taskNo: 43322,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43306',
                            description: '[Web] - Home banner stretched during resize',
                            taskNo: 43306,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/43307',
                            description: '[Web] - My profile side menu mobile view',
                            taskNo: 43307,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.12',
            date: moment('2024-11-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38519',
                            description: '[Web] My Learning - List and Filter UI',
                            taskNo: 38519,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42390',
                            description: '[WEB] CPE information page UI',
                            taskNo: 42390,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38530',
                            description: '[WEB] My Learning - API integration for listing and filtering',
                            taskNo: 38530,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.11',
            date: moment('2024-11-01'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38614',
                            description: '[Stag][User Portal] No Padding for Language & Hours Label',
                            taskNo: 38614,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38543',
                            description: '[Stag][User Portal] No Padding for the Progression Bar',
                            taskNo: 38543,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37542',
                            description: '[Stag][User Portal] No padding',
                            taskNo: 37542,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37309',
                            description: '[Stag][User Portal] No Alert Message',
                            taskNo: 37309,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38684',
                            description: '[Stag][User Portal] Incorrect Background Color for the Course.',
                            taskNo: 38684,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38665',
                            description: '[Stag][User Portal] Wrong Background Color and Border Shadow',
                            taskNo: 38665,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38658',
                            description: '[Stag][User Portal] No Animation on Arrow Icon',
                            taskNo: 38658,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38706',
                            description: '[Web] Program - Missing Live Information',
                            taskNo: 38706,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33705',
                            description: '[Web] Webinar - register a live webinar API integration',
                            taskNo: 33705,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42608',
                            description: '[Web] Webinar - Able to add webinar to Outlook/Google calendar',
                            taskNo: 42608,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.10',
            date: moment('2024-10-30'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/42389',
                            description: '[Web] set default font',
                            taskNo: 42389,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33673',
                            description: '[Web] Webinar Schedule - API Integration for List View UI',
                            taskNo: 33673,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33678',
                            description: '[Web] Webinar Schedule - API Integration for Calendar View',
                            taskNo: 33671,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33670',
                            description: '[Web] Webinar Schedule - Calendar View UI',
                            taskNo: 33670,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33675',
                            description: '[Web] Webinar Schedule - Details Popup UI (from calendar)',
                            taskNo: 33675,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.9',
            date: moment('2024-10-29'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38656',
                            description: '[Stag][User Portal] Different Shadow Background',
                            taskNo: 38656,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37935',
                            description: '[Stag][User Portal] Incorrect Title for Successful Password Creation',
                            taskNo: 37935,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.9',
            date: moment('2024-10-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33688',
                            description: '[Web] Course - API Integration for Details Page',
                            taskNo: 33688,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33678',
                            description: '[Web] Web - API Integration for Details Page',
                            taskNo: 33678,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/34285',
                            description: '[Web] Webinar / Home - Live Today API Integration',
                            taskNo: 34285,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37046',
                            description: '[Web] Course - Filter Option API Integration (Reopen)',
                            taskNo: 37046,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/39234',
                            description: '[Stag][User Portal] No Underline Below the Tab',
                            taskNo: 39234,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38644',
                            description: '[Stag][User Portal] No Padding for the Language Label',
                            taskNo: 38644,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38640',
                            description: '[Stag][User Portal] Incorrect Button Label',
                            taskNo: 38640,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38518',
                            description: '[Stag][User Portal] Able to Enter More Than 10 digits.',
                            taskNo: 38518,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37312',
                            description: '[Stag][User Portal] The words and lines are not aligned correctly.',
                            taskNo: 37312,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38161',
                            description: '[Stag][User Portal] Header Not Sticky on Scroll',
                            taskNo: 38161,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37319',
                            description: '[Stag][User Portal] Extra Border Displayed',
                            taskNo: 37319,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37316',
                            description: '[Stag][User Portal] The footer is not fully center',
                            taskNo: 37316,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.9',
            date: moment('2024-10-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33683',
                            description: '[Web] - API Integration for Upcoming Update Classes Section UI',
                            taskNo: 33683,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33669',
                            description: '[Web] - API integration Course Progress Indicator UI from Homepage',
                            taskNo: 33669,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/41795',
                            description: '[Web] - Upcoming Update Classes also hide the description',
                            taskNo: 41795,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37317',
                            description: '[Web] - My Favorite - Delete Confirmation Popup',
                            taskNo: 37317,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35304',
                            description: '[Web] Webinar - Featured Webinar API Integration',
                            taskNo: 35304,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.8',
            date: moment('2024-10-23'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37046',
                            description: '[Web] - Course: Filter Option API Integration',
                            taskNo: 37046,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.8',
            date: moment('2024-10-22'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/41485',
                            description: '[Web] - Home: Speaker Top Class API Integration',
                            taskNo: 41485,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/41299',
                            description: '[Web] - Showing console error in homepage',
                            taskNo: 41299,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.8',
            date: moment('2024-10-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/40936',
                            description: '[Web] Homepage - Profile menu dropdown UI',
                            taskNo: 40936,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38556',
                            description: '[Web] My Favorite - List API Integration',
                            taskNo: 38556,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35301',
                            description: '[Web] Course - Listing with filter API Integration',
                            taskNo: 35301,
                        },
                    ],
                },
            ],
            show: true,
        },
        {
            version: 'v0.0.7',
            date: moment('2024-10-17'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33672',
                            description: '[Web] Webinar Schedule - List View UI',
                            taskNo: 33672,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.7',
            date: moment('2024-10-16'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/40578',
                            description: '[Web] Homepage - UI Amendments and Set Maxwidth',
                            taskNo: 40578,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33680',
                            description: '[Web] Homepage - API Integration for Top Banner (Carousel)',
                            taskNo: 33680,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.7',
            date: moment('2024-10-15'),
            detail: [
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/40557',
                            description: '[Web] - Login UI Amendment ',
                            taskNo: 40557,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.6',
            date: moment('2024-10-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/40181',
                            description: '[Web] Course - Integrate Details Page',
                            taskNo: 40181,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35303',
                            description: '[Web] Webinar - Webinar Listing and Featured Webinar UI',
                            taskNo: 35303,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.6',
            date: moment('2024-10-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38102',
                            description: '[Web] Home - API Integration for Featured Series',
                            taskNo: 38102,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.6',
            date: moment('2024-10-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33649',
                            description: '[Web] Login - API Integration for Login & Remember Me feature',
                            taskNo: 33649,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.5',
            date: moment('2024-10-08'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33687',
                            description: '[Web] Home - API Integration for Course section from Homepage',
                            taskNo: 33687,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.5',
            date: moment('2024-10-07'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33677',
                            description: '[Web] Webinar - Details Page UI (Reusable page)',
                            taskNo: 33677,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33684',
                            description: '[Web] Class - Integrate reusable webinar details page UI',
                            taskNo: 33684,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33693',
                            description: '[Web] Home - API Integration for Speaker Details Section UI',
                            taskNo: 33693,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.4',
            date: moment('2024-10-04'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33686',
                            description: '[Web] Course - Details Page UI',
                            taskNo: 33686,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33693',
                            description: '[Web] Home - API Integration for Speaker Details Section UI',
                            taskNo: 33693,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.3',
            date: moment('2024-09-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/38364',
                            description: '[Web] Forgot Password - Update Send Reset Link Email Copyright',
                            taskNo: 38364,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33634',
                            description: '[Web] Package - API Integration to Package Retrieving',
                            taskNo: 33634,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33661',
                            description: '[Web] Reset Password - API Integration to reset password',
                            taskNo: 33661,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33665',
                            description: '[Web] Home / Feature Series - List UI (Swiper)',
                            taskNo: 33665,
                        },
                    ],
                },
                {
                    type: ReleaseType['Bug Fixes'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/TalentCorp%20MyMahir%20KESUMA%20Development/_workitems/edit/37291/',
                            description:
                                'fix: [Stag][User Portal] The title for the description and button is incorrect',
                            taskNo: 37291,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/TalentCorp%20MyMahir%20KESUMA%20Development/_workitems/edit/37331/',
                            description: 'fix: [Stag][User Portal] The footer has a different background color',
                            taskNo: 37331,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.3',
            date: moment('2024-09-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33663',
                            description: '[Web] Home - Featured Series Section UI',
                            taskNo: 33663,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.3',
            date: moment('2024-09-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33668',
                            description: '[Web] Home - Course Progress Indicator UI and goto top screen feature',
                            taskNo: 33668,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.2',
            date: moment('2024-09-24'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33667',
                            description: '[Web] Register - API Integration for Register and Create Password',
                            taskNo: 33667,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37044',
                            description: '[Web] Register - Update User Details and Payment Details Form UI',
                            taskNo: 37044,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.2',
            date: moment('2024-09-23'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/37538',
                            description: '[Web] Home - Our Latest Articles Section UI',
                            taskNo: 37538,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.2',
            date: moment('2024-09-23'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33690',
                            description: '[Web]Home - Speaker Details Section UI',
                            taskNo: 33690,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.2',
            date: moment('2024-09-19'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33682',
                            description: '[Web]Home - Upcoming Update Classes Section UI',
                            taskNo: 33682,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-18'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33712',
                            description: '[Web] Login - API Integration',
                            taskNo: 33712,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-13'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/36741',
                            description: '[Web]Home - Training / CPE Hours UI Section',
                            taskNo: 36741,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35282',
                            description: '[Web] Course - Course Grid View List',
                            taskNo: 35282,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35283',
                            description: '[Web] Course - Course Tile List',
                            taskNo: 35283,
                        },
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35300',
                            description: '[Web] Course - Filter UI & Page Layout',
                            taskNo: 35300,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-10'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33685',
                            description: '[Web]Home- Course Section UI',
                            taskNo: 33685,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-09'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/34283',
                            description: '[Web]Home - Webinar Live Today UI',
                            taskNo: 34283,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-06'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35678',
                            description: '[Web] Course - Featured Course UI From Details Page',
                            taskNo: 35678,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33679',
                            description: '[Web]feat: Home - Banner (Carousel) UI ',
                            taskNo: 33679,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-05'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35307',
                            description: '[Web]feat: Home - Page Layout and Navbar',
                            taskNo: 35307,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-09-02'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/35678',
                            description: '[Web] Course - Featured Course UI From Details Page',
                            taskNo: 25678,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33645',
                            description: '[Web]feat: Reset Password - Integrate create password UI component ',
                            taskNo: 33645,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33609',
                            description: '[Web]feat: Password set successfully UI',
                            taskNo: 33609,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33608',
                            description: '[Web]feat: Create a Password UI (Reusable)',
                            taskNo: 33608,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-29'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33607',
                            description: '[Web]feat: Register - Create Password Notification UI',
                            taskNo: 33607,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33646',
                            description: '[Web]feat: Register - reCAPTCHA (V3 Version) Integration',
                            taskNo: 33646,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-28'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/34461',
                            description: '[Web]feat: Register - Payment UI',
                            taskNo: 34461,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33604',
                            description: '[Web]feat: Register - User Details UI',
                            taskNo: 33604,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-27'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33658',
                            description: '[Web]feat: Login - Integrate recaptcha feature',
                            taskNo: 33658,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-26'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33602',
                            description: '[Web]feat: Login - Login Page UI',
                            taskNo: 33602,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-22'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33666',
                            description: '[Web] feat: Mobile App Download - Integrate App download link',
                            taskNo: 33666,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33632',
                            description: '[Web] feat: Book a Demo -Link Book A Demo button ',
                            taskNo: 33632,
                        },
                    ],
                },
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33606',
                            description: '[Web] feat: Authentication Layout - Header & Footer (Reusable)',
                            taskNo: 33606,
                        },
                    ],
                },
            ],
            show: false,
        },
        {
            version: 'v0.0.1',
            date: moment('2024-08-21'),
            detail: [
                {
                    type: ReleaseType['New Features'],
                    list: [
                        {
                            link: 'https://dev.azure.com/agmo/YYC%20taxPOD/_workitems/edit/33826',
                            description: '[Web] feat: Base codes setup',
                            taskNo: 33826,
                        },
                    ],
                },
            ],
            show: false,
        },
    ];

    knownIssues = [
        'Webinar / Course - The listing page has responsive and mobile view display issue',
        'Home - Featured Series UI has responsive UI display issue',
        'Register - Partially integrate the package API due to different from UI',
    ];

    selectedTab = this.tabs[0];

    showMore(list: ReleaseNoteModel): void {
        list.show = !list.show;
        this.releaseNoteList.forEach((item) => {
            if (item.version != list.version) item.show = false;
        });
    }
}

enum TabType {
    'Release Update',
    'Known Issues',
}

enum ReleaseType {
    'New Features', //new modules, new feature
    'Bug Fixes',
    'Improvements', //enhancement to the existing module
}

interface ReleaseNoteDetailModel {
    type: ReleaseType;
    list: ReleaseItemModel[];
}

interface ReleaseNoteModel {
    version: string;
    date: Moment;
    detail: ReleaseNoteDetailModel[];
    show: boolean;
}

interface ReleaseItemModel {
    link: string;
    description: string;
    taskNo: number;
}
